module.exports = __webpack_public_path__ + "assets/6934a028289448e4112c8834e0008ea5.png";